import { Injectable } from '@angular/core';
import { takeUntil } from 'rxjs';
import { WhiteLabelDashboardRepository } from 'src/app/core/data/repository';
import { Bloc, ErrorState, ShowLoadingComponentState } from 'src/app/shared/bloc/base-bloc';
import { NonDrawing } from 'src/app/shared/model';

import {
  StatisticsChartInitEvent,
  StatisticsCommentsInitEvent,
  StatisticsEvent,
  StatisticsPDFGendersEvent,
} from './statistics-event';
import {
  StatisticsChartReadyState,
  StatisticsCommentsLoadingState,
  StatisticsCommentsReadyState, StatisticsReadyPDFState,
  StatisticsState
} from './statistics-state';

@Injectable()
export class StatisticsBloc extends Bloc<StatisticsEvent, StatisticsState> {
  constructor(private whiteLabelDashboardRepository: WhiteLabelDashboardRepository) {
    super();
  }
  onIncomingEvents(event: StatisticsEvent): void {
    if (event instanceof StatisticsChartInitEvent) {
      // loading component
      this.onState$.next(new ShowLoadingComponentState(true));
      // call api
      this.whiteLabelDashboardRepository
        .getApplicationTotalSessionData(event.form)
        .pipe(takeUntil(this.destroy$))
        .subscribe({
          next: (result) => {
            this.onState$.next(new StatisticsChartReadyState(result));
          },
          error: (error) => {
            this.onState$.next(new ErrorState<NonDrawing>(new NonDrawing(), error));
          },
        });
    } else if (event instanceof StatisticsPDFGendersEvent) {
      // loading component
      this.onState$.next(new ShowLoadingComponentState(true));
      // call api
      this.whiteLabelDashboardRepository
        .getPDFGendersCount(event.form)
        .pipe(takeUntil(this.destroy$))
        .subscribe({
          next: (result) => {
            this.onState$.next(new StatisticsReadyPDFState(result));
          },
          error: (error) => {
            this.onState$.next(new ErrorState<NonDrawing>(new NonDrawing(), error));
          },
        });
    } else if (event instanceof StatisticsCommentsInitEvent) {
      // loading component
      this.onState$.next(new StatisticsCommentsLoadingState());
      // call api
      this.whiteLabelDashboardRepository
        .getUsersCommentsAndRate(event.form.categories)
        .pipe(takeUntil(this.destroy$))
        .subscribe({
          next: (result) => {
            this.onState$.next(new StatisticsCommentsReadyState(result));
          },
          error: (error) => {
            this.onState$.next(new ErrorState<NonDrawing>(new NonDrawing(), error));
          },
        });
    }
  }
}
